import { apiCreate, apiGetOne, apiUpdate } from './ApiBaseActions';
export const API_GET_LIST_SEARCH_CONSULTANT_COUNT = 'API_GET_LIST_SEARCH_CONSULTANT_COUNT';
export const API_GET_LIST_SEARCH_CONSULTANT_MULTI = 'API_GET_LIST_SEARCH_CONSULTANT_MULTI';
export const API_GET_LIST_SEARCH_CONSULTANT_SLIDE_PAGE_ONE = 'API_GET_LIST_SEARCH_CONSULTANT_SLIDE_PAGE_ONE';
export const API_GET_LIST_SEARCH_CONSULTANT_PS_SLIDE_PAGE_ONE = 'API_GET_LIST_SEARCH_CONSULTANT_PS_SLIDE_PAGE_ONE';
export const API_UPDATE_CONSULTANT_SEARCH_VIEW_REQUEST = 'API_UPDATE_CONSULTANT_SEARCH_VIEW_REQUEST';
export const API_UPDATE_CONSULTANT_SEARCH_RESULT_VIEW_REQUEST = 'API_UPDATE_CONSULTANT_SEARCH_RESULT_VIEW_REQUEST';
export const apiGetListConsultantSearchCount = (params, meta) => apiCreate(API_GET_LIST_SEARCH_CONSULTANT_COUNT, '/consultant_search/count', params, meta);
export const apiGetListConsultantSearchMulti = (params, meta) => apiCreate(API_GET_LIST_SEARCH_CONSULTANT_MULTI, '/consultant_search/search', params, meta);
export const apiUpdateConsultantSearchViewRequest = (id, meta) => apiUpdate(API_UPDATE_CONSULTANT_SEARCH_VIEW_REQUEST, `/consultant_search/search/${id}/view`, {}, meta);
export const apiUpdateConsultantSearchResultViewRequest = (id, resultId, params, meta) => apiUpdate(API_UPDATE_CONSULTANT_SEARCH_RESULT_VIEW_REQUEST, `/consultant_search/search/${id}/view/${resultId}`, params, meta);
/**
 * ページの取得
 * @param pageId
 * @param meta
 * @returns {*}
 */
export const apiGetOneConsultantSlideSearchPage = (pageId, meta) => apiGetOne(API_GET_LIST_SEARCH_CONSULTANT_SLIDE_PAGE_ONE, `/consultant_search/slide_page/${pageId}`, Object.assign({}, meta));
/**
 * PSスライド 詳細ページの取得
 * @param meta
 * @returns {Object}
 */
export const apiGetListConsultantPsSlidePage = (params, meta) => apiCreate(API_GET_LIST_SEARCH_CONSULTANT_PS_SLIDE_PAGE_ONE, '/consultant_search/ps_slide', params, Object.assign(Object.assign({}, (meta || {})), { ids: params.ids }));
